import Topbar from "../../components/Topbar";
import { useServicos } from "./hooks/useServicos";
import { STATUS } from "./constants";
import Calendario from "./components/Calendario";
import Mapa from "./components/Mapa";
import LinhaOS from "./components/LinhaOS";
import ModalOS from "./components/ModalOS";

export default function Servicos(){
  const s = useServicos();

  return(<>
    <Topbar title="Servicos"/>
    <div className="erp-content">
      <div className="page-toolbar">
        <button className="btn btn-primary" onClick={s.abrirNovo}><i className="ti ti-plus"/> Nova OS</button>
        <div className="flex-row" style={{flexWrap:"wrap",gap:4}}>
          {["","AGENDADO","EM_EXECUCAO","CONCLUIDO","CANCELADO"].map(st=>(
            <button key={st} className={"btn btn-secondary"+(s.filtroStatus===st&&s.abaVis==="lista"?" aba-ativa":"")}
              style={{fontSize:11,padding:"4px 10px"}} onClick={()=>{s.setFiltroStatus(st);s.setAbaVis("lista");}}>
              {st?STATUS[st]?.l:"Todos"}{st&&<span className="fs-11"> ({s.ordens.filter(o=>o.status===st).length})</span>}
            </button>
          ))}
          <button className={"btn btn-secondary"+(s.abaVis==="calendario"?" aba-ativa":"")} style={{fontSize:11,padding:"4px 10px"}} onClick={()=>s.setAbaVis("calendario")}>
            <i className="ti ti-calendar"/> Calendario
          </button>
          <button className={"btn btn-secondary"+(s.abaVis==="mapa"?" aba-ativa":"")} style={{fontSize:11,padding:"4px 10px"}} onClick={()=>s.setAbaVis("mapa")}>
            <i className="ti ti-map"/> Mapa
          </button>
        </div>
        <input className="form-input" style={{width:220}} placeholder="Buscar cliente ou OS#..." value={s.busca} onChange={e=>s.setBusca(e.target.value)}/>
      </div>

      {s.abaVis==="calendario"&&<Calendario ordens={s.ordens}/>}
      {s.abaVis==="mapa"&&<Mapa ordens={s.ordens}/>}
      {s.abaVis==="lista"&&(
        <div className="card">
          <div className="table-wrapper">
            {s.loading?<div className="table-empty">Carregando...</div>:
             !s.filtradas.length?<div className="table-empty">Nenhuma OS encontrada.</div>:(
              <table>
                <thead><tr><th>OS#</th><th>Cliente</th><th>Tipo</th><th>Tecnico</th><th>Data Agendada</th><th className="td-r">Total</th><th>Status</th><th></th></tr></thead>
                <tbody>{s.filtradas.map(o=><LinhaOS key={o.id} o={o} onEditar={s.abrirEditar} onExcluir={s.excluir} onMudarStatus={s.mudarStatus}/>)}</tbody>
              </table>
            )}
          </div>
        </div>
      )}
    </div>

    <ModalOS
      modalForm={s.modalForm} form={s.form} itens={s.itens}
      clientes={s.clientes} tecnicos={s.tecnicos} produtos={s.produtos} pedidos={s.pedidos}
      salvando={s.salvando}
      setF={s.setF} setItem={s.setItem} selectProduto={s.selectProduto}
      addItem={s.addItem} removeItem={s.removeItem} buscarCoordenadas={s.buscarCoordenadas}
      salvar={s.salvar} onFechar={()=>s.setModalForm(null)}
    />
  </>);
}
